import {
  AntragDruck,
  BeiblattDruckdaten,
  Dokument as BffDokument,
  DokumentenErstellungRequestModel,
  SparteDruckdaten,
  SpartenType,
  UriDruckdaten,
  VersichertePersonDruck,
} from '@ps20/bff-models';
import { getTarifbereich } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../localStore';
import {
  addCheckoutDataToSparteDruckdaten,
  mapBankverbindung,
  mapVermittler,
  mapVersicherungsnehmer,
} from './common-druckdaten.mapper';
import { mapBeibehaltenData } from './infopaket.mapper';

export function mapBeiblatt(
  state: IAppState,
  sparteDruckdaten: Array<SparteDruckdaten>,
): DokumentenErstellungRequestModel<BeiblattDruckdaten> {
  return {
    dokumentDruckdaten: {
      dokument: BffDokument.BEIBLATT,
      beibehaltenData: mapBeibehaltenData(state),
      versichertePersonen: getAllVersichertePersonenForBeiblatt(sparteDruckdaten),
    },
    antraege: mapAntraegeMitBeibehaltung(sparteDruckdaten),
    sammelantragsnummer: state.sammelantragsnummer,
    bankverbindung: mapBankverbindung(state),
    vermittler: mapVermittler(state),
    sparteDruckdaten: spartenDruckDatenForBeiblatt(sparteDruckdaten, state),
    versicherungsnehmer: mapVersicherungsnehmer(state),
    vertragsschlussverfahren: state.vertragsschlussverfahren,
    zahlungsmethode: {
      zahlungsart: state.zahlung.zahlungsart,
      zahlweise: state.zahlung.zahlweise,
    },
    tarifbereich: getTarifbereich(state.versicherungsnehmer),
  };
}

export function getAllVersichertePersonenForBeiblatt(
  sparteDruckdaten: Array<SparteDruckdaten>,
): Array<VersichertePersonDruck> {
  const druckDatenArray: Array<SparteDruckdaten> = sparteDruckdaten.filter(
    sparteDruckdata => sparteDruckdata.spartenType === SpartenType.UNFALL,
  );
  if (!druckDatenArray || druckDatenArray.length === 0) {
    return;
  }
  return druckDatenArray.map(druckDaten => (druckDaten as UriDruckdaten).versichertePerson);
}

function spartenDruckDatenForBeiblatt(
  sparteDruckdaten: Array<SparteDruckdaten>,
  state: IAppState,
): SparteDruckdaten {
  const druckDaten = sparteDruckdaten.find(
    sparteDruckdata => sparteDruckdata.spartenType === SpartenType.UNFALL,
  );
  if (!druckDaten) {
    return;
  }
  return addCheckoutDataToSparteDruckdaten(state, druckDaten);
}

function mapAntraegeMitBeibehaltung(sparteDruckdaten: Array<SparteDruckdaten>): AntragDruck[] {
  return sparteDruckdaten.map(sparteDruckdata => ({
    antragsnummer: sparteDruckdata.antragsnummer,
    longText: sparteDruckdata.longText,
    shortText: sparteDruckdata.shortText,
    spartenType: sparteDruckdata.spartenType,
    beibehalten: sparteDruckdata.beibehalten,
  }));
}
